(function ($, window, document) {
  'use strict';
  $(function () {
    //##Variables
    var $body = $('body'),
      $window = $(window),
      $doc = $(document),
      $hamburger = $('.hamburger'),
      $blueWrap = $('.blueWrap'),
      $formtoggle = $('.formtoggle'),
      $searchText = $('.search_text'),
      defaultEasing = [0.4, 0.0, 0.2, 1];
    //End Variables

    $formtoggle.click(function () {
      $(this).toggleClass('toggled');
      $searchText.fadeToggle('fast');
      $(".headerForm [name='s']").focus();
    });

    $hamburger.click(function () {
      $(this).toggleClass('toggled');
      $blueWrap.fadeToggle('fast');
    });

    (function ($) {
      $(window).on('load', function () {
        if ($(window).width() > 981) {
          $('.customScroll').mCustomScrollbar({
            scrollInertia: 200,
            theme: 'minimal',
          });
        }
      });
    })(jQuery);

    $('#news_ticker').marquee({ direction: 'horizontal', delay: 0, timing: 50 });

    $('#newsBanner').owlCarousel({
      loop: true,
      nav: true,
      dots: true,
      items: 1,
      responsive: {
        0: {
          autoplay: true,
        },
        982: {
          autoplay: false,
        },
      },
    });

    if ($(window).width() > 981) {
      $('#newsAktualitete').owlCarousel({
        loop: true,
        nav: true,
        autoplay: false,
        dots: false,
        items: 1,
      });
      $('#newsWorldWide').owlCarousel({
        loop: true,
        nav: true,
        autoplay: false,
        dots: false,
        items: 1,
      });
      $('#rajoniSlider').owlCarousel({
        loop: true,
        nav: true,
        autoplay: true,
        dots: false,
        items: 1,
      });
      $('#botaSlider').owlCarousel({
        loop: true,
        nav: true,
        autoplay: true,
        dots: false,
        items: 1,
      });
    }

    $('#showbizz').owlCarousel({
      loop: true,
      nav: true,
      autoplay: true,
      dots: false,
      items: 4,
      responsiveClass: true,
      responsive: {
        0: {
          items: 1,
          nav: true,
          autoplay: true,
        },
        767: {
          items: 1,
          nav: true,
        },
        768: {
          items: 4,
          nav: true,
        },
      },
    });

    $('#newsImgSlider').owlCarousel({
      loop: true,
      nav: true,
      dots: false,
      items: 1,
      responsive: {
        0: {
          autoplay: false,
        },
        982: {
          autoplay: true,
        },
      },
    });

    // $('#sportSlider').owlCarousel({
    //     loop:true,
    //     nav:true,
    //     autoplay: true,
    //     dots:false,
    //     items:1
    // });

    // $('#showbizzSlider').owlCarousel({
    //     loop:true,
    //     nav:true,
    //     autoplay: true,
    //     dots:false,
    //     items:1
    // });

    $('#showbizzRightside').owlCarousel({
      loop: true,
      nav: true,
      dots: false,
      items: 1,
      responsive: {
        0: {
          autoplay: false,
        },
        982: {
          autoplay: true,
        },
      },
    });

    console.log('%c Developed by: Kutia Digital Agency http://kutia.net', 'padding:9px 5px; background:#3c4952; line-height:25px;color: #59bf9d');
  });
})(window.jQuery, window, document);
